import { render } from "./Task.vue?vue&type=template&id=493eb3da&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=493eb3da&scoped=true&lang=css"

import exportComponent from "/Users/alexkval/src/vue/vue-crash-2022/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493eb3da"]])

export default __exports__